import React, { useState, useCallback, useContext } from 'react';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import Instances from './Instances';
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../../Renderers/GlobalContext';
import SyncTenants from '../../Tenants/SyncTenants';
import { TenantsAppProvider } from '../../../Context/TenantsApp/TenantsAppContext';
import { usePropsStoreValue } from '../../../Hooks/PropStore/usePropsStore';

const InstanceManager = ({ updateProjectData }) => {
    const { t } = useTranslation("Instances/Instances");

    const { organization, subscription } = useContext(GlobalContext).state;

    const project = usePropsStoreValue("project");

    const hideTabs = organization.isTenantOrganization || subscription.numOfTenantApps === 0 || !project.masterApp;

    const [selectedTab, setSelectedTab] = useState(0);

    const handleTabSelect = useCallback((e) => {
        setSelectedTab(e.selected);
    }, []);

    return (
        <div className='h-100'>
            {hideTabs ? (
                <div className="enviroment-tab h-100">
                    <Instances updateProjectData={updateProjectData} />
                </div>
            ) : (
                <TabStrip
                    className="h-100"
                    selected={selectedTab}
                    onSelect={handleTabSelect}
                    animation={false}
                >
                    <TabStripTab title={t("tabs.environments", "Environments")}>
                        <div className="enviroment-tab h-100">
                            <Instances updateProjectData={updateProjectData} />
                        </div>
                    </TabStripTab>
                    <TabStripTab title={t("tabs.tenants", "Tenants")} >
                        <div className="tenant-tab h-100">
                            <TenantsAppProvider>
                                <SyncTenants />
                            </TenantsAppProvider>
                        </div>
                    </TabStripTab>
                </TabStrip>
            )
            }
        </div>
    );
}

export default InstanceManager;
